import axios from '../axios';
import { IOfferNote } from '../interfaces/domain';

export const getNotes = async (offerId: string): Promise<IOfferNote[]> => {
  const response = await axios.get(`/json/offer-notes?offerId=${offerId}`);
  return response.data || [];
};

export const saveNote = async (offerId: string, content: string): Promise<IOfferNote> => {
  const response = await axios.post('/json/offer-notes', { offerId, content });
  return response.data;
};

export const updateNote = async (id: string, content: string): Promise<IOfferNote> => {
  const response = await axios.put(`/json/offer-notes/${id}`, { content });
  return response.data;
};

export const deleteNote = async (id: string): Promise<void> => {
  await axios.delete(`/json/offer-notes/${id}`);
};

const OfferNoteService = {
  getNotes,
  saveNote,
  updateNote,
  deleteNote
};

export default OfferNoteService;
